import { useEffect, useState } from "react";
import api from "../api/api";

function Payments() {
  const [bill,    setBill]    = useState(null);
  const [mode,    setMode]    = useState("UPI");
  const [loading, setLoading] = useState(true);
  const [paying,  setPaying]  = useState(false);

  useEffect(() => {
    api.get("/payment/bill")
      .then(res => {
        const d = res.data.data || res.data;
        setBill(d || null);
      })
      .catch(() => setBill(null))
      .finally(() => setLoading(false));
  }, []);

  // const pay = async () => {
  //   if (!bill) return;
  //   setPaying(true);
  //   try {
  //     await api.post("/payment/pay", {
  //       paymentMode: mode,
  //       invoiceId: bill.invoiceId,
  //     });
  //     alert("Payment successful! ✅");
  //     setBill(null);
  //   } catch {
  //     alert("Payment failed ❌. Please try again.");
  //   } finally {
  //     setPaying(false);
  //   }
  // };

  const pay = async () => {

  setPaying(true); // ✅ start loading

  try {

    const res = await api.post(`/payment/create-order/${bill.invoiceId}`);
    const { orderId, amount } = res.data;

    const options = {
      key: "rzp_test_SX7vqmXKyQThaD",
      amount: amount * 100,
      currency: "INR",
      name: "PressManager",
      description: "Newspaper Payment",
      order_id: orderId,

      handler: async function (response) {

        await api.post("/payment/verify", {
          invoiceId: bill.invoiceId,
          orderId,
          paymentId: response.razorpay_payment_id,
          signature: response.razorpay_signature
        });

        alert("Payment successful ✅");
        setBill(null);
        setPaying(false); // ✅ stop loading
      },

      modal: {
        ondismiss: function () {
          setPaying(false); // ✅ if user cancels
        }
      },

      method: {
        upi: mode === "UPI",
        card: mode === "CARD",
        netbanking: false,
        wallet: false
      }
    };

    const rzp = new window.Razorpay(options);
    rzp.open();

  } catch (err) {
    alert("Payment failed ❌");
    setPaying(false); // ✅ reset on error
  }
};
  if (loading) return <p className="text-muted fs-13">Loading bill…</p>;

  if (!bill || bill.totalAmount <= 0) return (
    <div className="empty-state">
      <div className="empty-icon">🎉</div>
      <div className="empty-title">No pending bill</div>
      <div className="empty-sub">You're all caught up!</div>
    </div>
  );

  return (
    <div>
      {/* ── Bill Hero ─────────────────────────── */}
      <div className="payment-hero">
        <div className="payment-hero-label">Total Payable</div>
        <div className="payment-hero-amount">₹{bill.totalAmount}</div>
        <div className="payment-hero-meta">
          <div>
            <div className="phm-label">Newspaper</div>
            <div className="phm-value">{bill.newspaperName}</div>
          </div>
          <div>
            <div className="phm-label">Billing Period</div>
            <div className="phm-value">{bill.billingMonth}/{bill.billingYear}</div>
          </div>
          <div>
            <div className="phm-label">Plan</div>
            <div className="phm-value">{bill.billingType}</div>
          </div>
          {bill.lateFee > 0 && (
            <div>
              <div className="phm-label">Late Fee</div>
              <div className="phm-value" style={{ color: "#ff8a80" }}>+₹{bill.lateFee}</div>
            </div>
          )}
        </div>
      </div>

      {/* ── Payment Form ──────────────────────── */}
      <div className="card">
        <div className="card-header">
          <div className="card-title">Select Payment Mode</div>
        </div>
        <div className="card-body">
          <div style={{ display: "flex", gap: 10, marginBottom: 20, flexWrap: "wrap" }}>
            {["UPI", "CARD", "CASH", "WALLET"].map(m => (
              <button
                key={m}
                className={`btn ${mode === m ? "btn-gold" : "btn-outline"}`}
                onClick={() => setMode(m)}
              >
                {m === "UPI" ? "📲" : m === "CARD" ? "💳" : m === "CASH" ? "💵" : "👛"} {m}
              </button>
            ))}
          </div>

          <div style={{
            background: "var(--cream)", borderRadius: 8, padding: "14px 18px",
            marginBottom: 18, fontSize: 14
          }}>
            <div className="flex-between">
              <span className="text-muted">Base Amount</span>
              <span className="fw-600">₹{bill.baseAmount}</span>
            </div>
            {bill.lateFee > 0 && (
              <div className="flex-between mt-8">
                <span className="text-danger">Late Fee</span>
                <span className="text-danger fw-600">+₹{bill.lateFee}</span>
              </div>
            )}
            <div className="flex-between mt-8" style={{ borderTop: "1px solid var(--border)", paddingTop: 8 }}>
              <span className="fw-700">Total</span>
              <span className="fw-700 text-gold" style={{ fontFamily: "'Playfair Display', serif", fontSize: 18 }}>
                ₹{bill.totalAmount}
              </span>
            </div>
          </div>

          <button
            className="btn btn-gold btn-lg"
            onClick={pay}
            disabled={paying}
          >
            {paying ? "Processing…" : `💳 Pay ₹${bill.totalAmount} via ${mode}`}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Payments;
